module.exports = __webpack_public_path__ + "static/media/yara.fa24f543.png";